import React from "react";
import PartsPerPsmContainer from "../containers/PartsPerPsmContainer";

export const PartsPerPsmPage: React.FunctionComponent = () => <PartsPerPsmContainer />;